export default __webpack_public_path__ + "static/media/nomady-social-media-mountain-600x314.b359f93f.jpg";